import { Environments, getEnvironmentStringFromHost } from './environment';
import { getRegionSuffix } from './getRegion';
import { Region } from '../types/region.types';
import { getProductSubdomain } from './getProduct';

interface GenerateHostConfig {
	env?: Environments;
	region?: Region;
	product?: string;
	autodesk?: boolean;
}

/**
 * Generates a host based on the config. If no value is present on the config, will use the current environment, region, and product.
 * @param config - Allows configuration of environment, region, and product when generating a host.
 * @returns The generated host
 */
export const generateHost = (
	config: Partial<GenerateHostConfig> | undefined,
) => {
	const {
		env = getEnvironmentStringFromHost(),
		region = getRegionSuffix(),
		product = getProductSubdomain(),
		autodesk = window.location.host.includes('autodesk'),
	} = config || {};

	// In case of localhost, return the current host
	if (product === 'localhost') {
		return window.location.host;
	}

	const regionString =
		region.length > 0 && region !== Region.US ? `-${region}` : '';
	const productString = product ? `${product}.` : '';

	return `${productString}info360${regionString}${env}${
		autodesk ? '.autodesk.com' : '.com'
	}`;
};
